// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IIsPayClaimsAbsencePropertyDto } from './IIsPayClaimsAbsencePropertyDto';
import {
    IIsPayClaimsAbsencePropertyDtoFromJSON,
    IIsPayClaimsAbsencePropertyDtoFromJSONTyped,
    IIsPayClaimsAbsencePropertyDtoToJSON,
    IIsPayClaimsAbsencePropertyDtoToJSONTyped,
} from './IIsPayClaimsAbsencePropertyDto';
import type { IRunOutPropertyDto } from './IRunOutPropertyDto';
import {
    IRunOutPropertyDtoFromJSON,
    IRunOutPropertyDtoFromJSONTyped,
    IRunOutPropertyDtoToJSON,
    IRunOutPropertyDtoToJSONTyped,
} from './IRunOutPropertyDto';
import type { IClaimsDeadlineEndOfCoveragePropertyDto } from './IClaimsDeadlineEndOfCoveragePropertyDto';
import {
    IClaimsDeadlineEndOfCoveragePropertyDtoFromJSON,
    IClaimsDeadlineEndOfCoveragePropertyDtoFromJSONTyped,
    IClaimsDeadlineEndOfCoveragePropertyDtoToJSON,
    IClaimsDeadlineEndOfCoveragePropertyDtoToJSONTyped,
} from './IClaimsDeadlineEndOfCoveragePropertyDto';
import type { IEndOfCoveragePropertyDto } from './IEndOfCoveragePropertyDto';
import {
    IEndOfCoveragePropertyDtoFromJSON,
    IEndOfCoveragePropertyDtoFromJSONTyped,
    IEndOfCoveragePropertyDtoToJSON,
    IEndOfCoveragePropertyDtoToJSONTyped,
} from './IEndOfCoveragePropertyDto';
import type { IAiAdjudicationPropertyDto } from './IAiAdjudicationPropertyDto';
import {
    IAiAdjudicationPropertyDtoFromJSON,
    IAiAdjudicationPropertyDtoFromJSONTyped,
    IAiAdjudicationPropertyDtoToJSON,
    IAiAdjudicationPropertyDtoToJSONTyped,
} from './IAiAdjudicationPropertyDto';
import type { IIsPayClaimsOutsideCoveragePropertyDto } from './IIsPayClaimsOutsideCoveragePropertyDto';
import {
    IIsPayClaimsOutsideCoveragePropertyDtoFromJSON,
    IIsPayClaimsOutsideCoveragePropertyDtoFromJSONTyped,
    IIsPayClaimsOutsideCoveragePropertyDtoToJSON,
    IIsPayClaimsOutsideCoveragePropertyDtoToJSONTyped,
} from './IIsPayClaimsOutsideCoveragePropertyDto';
import type { IGracePeriodPropertyDto } from './IGracePeriodPropertyDto';
import {
    IGracePeriodPropertyDtoFromJSON,
    IGracePeriodPropertyDtoFromJSONTyped,
    IGracePeriodPropertyDtoToJSON,
    IGracePeriodPropertyDtoToJSONTyped,
} from './IGracePeriodPropertyDto';

/**
 * 
 * @export
 * @interface IPlanCoverageConfigDto
 */
export interface IPlanCoverageConfigDto {
    /**
     * 
     * @type {IGracePeriodPropertyDto}
     * @memberof IPlanCoverageConfigDto
     */
    grace_period_type?: IGracePeriodPropertyDto;
    /**
     * 
     * @type {IRunOutPropertyDto}
     * @memberof IPlanCoverageConfigDto
     */
    run_out_type?: IRunOutPropertyDto;
    /**
     * 
     * @type {IEndOfCoveragePropertyDto}
     * @memberof IPlanCoverageConfigDto
     */
    end_of_coverage_type?: IEndOfCoveragePropertyDto;
    /**
     * 
     * @type {IClaimsDeadlineEndOfCoveragePropertyDto}
     * @memberof IPlanCoverageConfigDto
     */
    claims_deadline_end_of_coverage_type?: IClaimsDeadlineEndOfCoveragePropertyDto;
    /**
     * 
     * @type {IIsPayClaimsAbsencePropertyDto}
     * @memberof IPlanCoverageConfigDto
     */
    is_pay_claims_absence?: IIsPayClaimsAbsencePropertyDto;
    /**
     * 
     * @type {IIsPayClaimsOutsideCoveragePropertyDto}
     * @memberof IPlanCoverageConfigDto
     */
    is_pay_claims_outside_coverage?: IIsPayClaimsOutsideCoveragePropertyDto;
    /**
     * 
     * @type {IAiAdjudicationPropertyDto}
     * @memberof IPlanCoverageConfigDto
     */
    ai_adjudication_type?: IAiAdjudicationPropertyDto;
}

/**
 * Check if a given object implements the IPlanCoverageConfigDto interface.
 */
export function instanceOfIPlanCoverageConfigDto(value: object): value is IPlanCoverageConfigDto {
    return true;
}

export function IPlanCoverageConfigDtoFromJSON(json: any): IPlanCoverageConfigDto {
    return IPlanCoverageConfigDtoFromJSONTyped(json, false);
}

export function IPlanCoverageConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanCoverageConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'grace_period_type': json['grace_period_type'] == null ? undefined : IGracePeriodPropertyDtoFromJSON(json['grace_period_type']),
        'run_out_type': json['run_out_type'] == null ? undefined : IRunOutPropertyDtoFromJSON(json['run_out_type']),
        'end_of_coverage_type': json['end_of_coverage_type'] == null ? undefined : IEndOfCoveragePropertyDtoFromJSON(json['end_of_coverage_type']),
        'claims_deadline_end_of_coverage_type': json['claims_deadline_end_of_coverage_type'] == null ? undefined : IClaimsDeadlineEndOfCoveragePropertyDtoFromJSON(json['claims_deadline_end_of_coverage_type']),
        'is_pay_claims_absence': json['is_pay_claims_absence'] == null ? undefined : IIsPayClaimsAbsencePropertyDtoFromJSON(json['is_pay_claims_absence']),
        'is_pay_claims_outside_coverage': json['is_pay_claims_outside_coverage'] == null ? undefined : IIsPayClaimsOutsideCoveragePropertyDtoFromJSON(json['is_pay_claims_outside_coverage']),
        'ai_adjudication_type': json['ai_adjudication_type'] == null ? undefined : IAiAdjudicationPropertyDtoFromJSON(json['ai_adjudication_type']),
    };
}

export function IPlanCoverageConfigDtoToJSON(json: any): IPlanCoverageConfigDto {
    return IPlanCoverageConfigDtoToJSONTyped(json, false);
}

export function IPlanCoverageConfigDtoToJSONTyped(value?: IPlanCoverageConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'grace_period_type': IGracePeriodPropertyDtoToJSON(value['grace_period_type']),
        'run_out_type': IRunOutPropertyDtoToJSON(value['run_out_type']),
        'end_of_coverage_type': IEndOfCoveragePropertyDtoToJSON(value['end_of_coverage_type']),
        'claims_deadline_end_of_coverage_type': IClaimsDeadlineEndOfCoveragePropertyDtoToJSON(value['claims_deadline_end_of_coverage_type']),
        'is_pay_claims_absence': IIsPayClaimsAbsencePropertyDtoToJSON(value['is_pay_claims_absence']),
        'is_pay_claims_outside_coverage': IIsPayClaimsOutsideCoveragePropertyDtoToJSON(value['is_pay_claims_outside_coverage']),
        'ai_adjudication_type': IAiAdjudicationPropertyDtoToJSON(value['ai_adjudication_type']),
    };
}

